import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Button, Card, CardBody, CardRibbon, Flex } from '@pancakeswap/uikit'
import { cronosTokens } from '@pancakeswap/tokens'
import { useWeb3React } from '@pancakeswap/wagmi'
import { useTranslation } from '@pancakeswap/localization'
import { ToastDescriptionWithTx } from 'components/Toast'
import useToast from 'hooks/useToast'
import useCatchTxError from 'hooks/useCatchTxError'
import { LockData, LockStatus } from '../../types'
import LockCardHeader from './LockCardHeader'
import { getStatus } from '../../hooks/helpers'
import LockTimer from '../LockTimer'
import LockCardDetails from './LockCardDetails'
import useLockToken from '../../hooks/useLockToken'

const StyledLockCard = styled(Card)`
  background-repeat: no-repeat;
  background-size: contain;
  margin-left: auto;
  margin-right: auto;
  max-width: 437px;
  width: 100%;
`

const LockCard: React.FC<{ data: LockData; onUnlocked: () => void }> = ({ data, onUnlocked }) => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { toastSuccess } = useToast()
  const { fetchWithCatchTxError, loading: pendingTx } = useCatchTxError()

  const candyToken = cronosTokens.candy

  const {
    amount,
    duration,
    lid,
    lockAt,
    unlocked
  } = data

  const { onUnlock } = useLockToken()
  const [state, setState] = useState({
    status: null,
    currentTime: Math.floor(Date.now() / 1000),
  })

  const handleUnlock = async () => {
    const receipt = await fetchWithCatchTxError(() => {
      return onUnlock(lid)
    })
    if (receipt?.status) {
      toastSuccess(
        `${t('Unlocked')}!`,
        <ToastDescriptionWithTx txHash={receipt.transactionHash}>
          {t('Unlocked tokens have been sent to your wallet!')}
        </ToastDescriptionWithTx>,
      )
      onUnlocked?.()
    }
  }

  useEffect(() => {
    const interval = setInterval(async () => {
      const currentTime = Math.floor(Date.now() / 1000)
      const status = getStatus(currentTime, lockAt, duration)
      setState({ status, currentTime })
    }, 1000)
    return () => clearInterval(interval)
  }, [lockAt, duration])

  return (
    <StyledLockCard>
      <CardBody style={{ padding: '24px 16px' }}>
        <LockCardHeader name={candyToken.name} address={candyToken.address} />
        <LockTimer currentTime={state.currentTime} duration={duration} lockAt={lockAt} unlocked={unlocked} />
        <LockCardDetails data={data} />
        {/* {state.status === 'finished' && !unlocked ? (
          <Flex justifyContent='center' mt='12px'>
            <Button disabled={pendingTx} width='240px' onClick={handleUnlock}>{t('Unlock')}</Button>
          </Flex>
        ) : null} */}
      </CardBody>
    </StyledLockCard>
  )
}

export default LockCard
